import React, { useEffect, useState } from "react";
import { X, DeviceMobile } from "@phosphor-icons/react";
import AppStoreButtons from "@/components/AppStoreButtons";
import { useI18n } from "@/context/I18nContext";

const DISMISS_KEY = "tf_app_banner_dismissed_at";
const DISMISS_DAYS = 7;

function recentlyDismissed() {
  const ts = Number(localStorage.getItem(DISMISS_KEY) || 0);
  if (!ts) return false;
  const ageDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
  return ageDays < DISMISS_DAYS;
}

/**
 * Slim "Get the mobile app" banner that sits above the page header. Dark
 * background to match the brand. Shows on every page until dismissed (then
 * stays hidden for 7 days).
 */
export default function AppDownloadBanner() {
  const { lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!recentlyDismissed());
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  return (
    <div
      data-testid="app-download-banner"
      className="relative w-full border-b"
      style={{
        background: "linear-gradient(90deg, #007AFF 0%, #0a66d0 100%)",
        borderColor: "rgba(255,255,255,0.15)",
        color: "white",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <DeviceMobile weight="duotone" size={20} className="shrink-0" />
          <div className="min-w-0 flex flex-col sm:flex-row sm:items-baseline sm:gap-2">
            <span className="text-xs sm:text-sm font-bold uppercase tracking-widest truncate">
              {lang === "da" ? "TeamFit mobil-app" : "TeamFit mobile app"}
            </span>
            <span className="hidden sm:inline text-xs text-white/80 truncate">
              {lang === "da"
                ? "Cykling · Løb · Padel — overalt hvor du er."
                : "Cycling · Running · Padel — wherever you are."}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <AppStoreButtons size="sm" />
          <button
            type="button"
            onClick={dismiss}
            data-testid="app-banner-dismiss"
            aria-label={lang === "da" ? "Luk" : "Close"}
            className="ml-1 p-1 hover:bg-white/10 transition"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
}
